import { cx } from 'class-variance-authority'

type PicturesDropZoneProps = {
  dropActive: boolean
  dragOver: (e: React.DragEvent<HTMLDivElement>) => void
  dragleave: (e: React.DragEvent<HTMLDivElement>) => void
  drop: (e: React.DragEvent<HTMLDivElement>) => void
  disabled: boolean
  handleFile: (e: React.ChangeEvent<HTMLInputElement>) => void
  processingOptionRef: React.RefObject<HTMLInputElement | null>
}

export const PicturesDropZone = ({
  dropActive,
  dragOver,
  dragleave,
  drop,
  disabled,
  handleFile,
  processingOptionRef,
}: PicturesDropZoneProps) => (
  <div className="flex w-full flex-grow flex-col gap-4">
    <div
      className={cx(
        ' mt-1 flex w-full flex-grow items-center justify-center rounded-md border-2 border-dashed px-6',
        {
          'border-primary-500': dropActive,
          'border-gray-300': !dropActive,
        },
      )}
    >
      <div
        className="flex h-full w-full flex-col items-center justify-center p-4 text-center"
        onDragOver={dragOver}
        onDragLeave={dragleave}
        onDrop={drop}
      >
        <label htmlFor="image">
          <svg
            className="mx-auto h-20 w-20 text-gray-400"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 48 48"
            aria-hidden="true"
          >
            <path
              d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </label>
        <div className="flex gap-1 text-lg text-gray-600">
          <label
            htmlFor="image"
            className="relative cursor-pointer rounded-md bg-white font-medium text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-primary-500 focus-within:ring-offset-2 hover:text-primary-500"
          >
            <span>Sélectionnez les photos</span>
          </label>
          <span>ou</span>
          <p>glissez-les ici</p>
        </div>
        <p className="text-sm text-gray-500">PNG ou JPG, max 10mo / fichier</p>
      </div>
      <input
        id="image"
        name="image"
        type="file"
        className="sr-only"
        disabled={disabled}
        accept="image/png, image/jpeg"
        onChange={handleFile}
        multiple
      />
    </div>
    <div className="flex space-x-2 text-sm text-slate-500">
      <input
        ref={processingOptionRef}
        type="checkbox"
        name="skipProcessing"
        id="skipProcessing"
        className="mt-0.5 h-4 w-4 rounded border-gray-500 text-primary-500 focus:ring-primary-500"
        defaultChecked
      />
      <label htmlFor="skipProcessing">
        <span className="block">
          Optimiser automatiquement le poids des images
        </span>
        <span className="block text-slate-100">
          Désactiver cette option peut améliorer la compatibilité avec certains
          navigateurs
        </span>
      </label>
    </div>
  </div>
)
